export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Resumen.vue?vue&type=template&id=094b7350&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/DetailsResidencial/Resumen.vue?vue&type=template&id=094b7350&
// module id = null
// module chunks = 